export default __webpack_public_path__ + "static/media/home-page-2-small.615366b9.jpg";